// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ItemsView_wrapper__3P9nz","centerWrapper":"ItemsView_centerWrapper__317hl"};